import { Validators } from '@angular/forms';
import { FormField, TableSection, ActionButton } from '@shared/components/add-form/add-form.component';

export interface GoodsShopFormConfig {
  title: string;
  formFields: FormField[];
  tableSections: TableSection[];
  headerActions: ActionButton[];
  listRoute: string;
}

export interface GoodsShopItem {
  id: number;
  spuId: number;
  spuCode: string;
  shopId: number;
  status: number;
  deleteFlag: number;
  tenantId: number;
  objectVersionNumber: number;
  creationDate?: string;
  lastUpdateDate?: string;
  createdBy?: string;
  lastUpdatedBy?: string;
}

export const STATUS_OPTIONS = [
  { label: 'On Shelf', value: 1 },
  { label: 'Off Shelf', value: 0 }
];

export const GOODS_SHOP_FORM_CONFIG: GoodsShopFormConfig = {
  title: 'Add Product to Store',
  formFields: [
    {
      label: 'SPU ID',
      controlName: 'spuId',
      type: 'number',
      placeholder: 'Enter SPU ID',
      required: true,
      section: 'basic',
      width: 'w-full',
      min: 1,
      validators: [Validators.required, Validators.min(1)]
    },
    {
      label: 'SPU Code',
      controlName: 'spuCode',
      type: 'text',
      placeholder: 'Enter SPU Code',
      required: true,
      section: 'basic',
      width: 'w-full',
      maxLength: 100,
      validators: [Validators.required, Validators.maxLength(100)]
    },
    {
      label: 'Shop ID',
      controlName: 'shopId',
      type: 'number',
      placeholder: 'Enter Shop ID',
      required: true,
      section: 'basic',
      width: 'w-full',
      min: 1,
      validators: [Validators.required, Validators.min(1)]
    },
    {
      label: 'Status',
      controlName: 'status',
      type: 'dropdown',
      placeholder: 'Select Status',
      required: true,
      section: 'basic',
      width: 'w-full',
      options: [
        { label: '1 (On Shelf)', value: 1 },
        { label: '0 (Off Shelf)', value: 0 }
      ],
      validators: [Validators.required]
    },
    {
      label: 'Delete Flag',
      controlName: 'deleteFlag',
      type: 'number',
      placeholder: 'Enter Delete Flag (0 = Active, 1 = Deleted)',
      required: false,
      section: 'basic',
      width: 'w-full',
      min: 0,
      max: 1,
      defaultValue: 0,
      validators: [Validators.min(0), Validators.max(1)]
    },
    {
      label: 'Tenant ID',
      controlName: 'tenantId',
      type: 'number',
      placeholder: 'Enter Tenant ID',
      required: false,
      section: 'basic',
      width: 'w-full',
      min: 0,
      defaultValue: 0,
      validators: [Validators.min(0)]
    },
    {
      label: 'Object Version Number',
      controlName: 'objectVersionNumber',
      type: 'number',
      placeholder: 'Enter Object Version Number',
      required: false,
      section: 'basic',
      width: 'w-full',
      min: 0,
      defaultValue: 1,
      validators: [Validators.min(0)]
    }
  ],
  tableSections: [
    {
      title: 'Product Store Relationships',
      show: true,
      columns: [
        {
          prop: 'id',
          label: 'ID',
          width: 80
        },
        {
          prop: 'spuId',
          label: 'SPU ID',
          width: 120
        },
        {
          prop: 'spuCode',
          label: 'SPU Code',
          width: 150
        },
        {
          prop: 'shopId',
          label: 'Shop ID',
          width: 120
        },
        {
          prop: 'status',
          label: 'Status',
          width: 120,
          type: 'status'
        },
        {
          prop: 'deleteFlag',
          label: 'Delete Flag',
          width: 120
        },
        {
          prop: 'tenantId',
          label: 'Tenant ID',
          width: 120
        },
        {
          prop: 'creationDate',
          label: 'Created Date',
          width: 150
        },
        {
          prop: 'createdBy',
          label: 'Created By',
          width: 120
        },
        {
          prop: 'lastUpdateDate',
          label: 'Last Updated',
          width: 150
        },
        {
          prop: 'lastUpdatedBy',
          label: 'Last Updated By',
          width: 150
        }
      ],
      data: [],
      actions: [
        {
          label: 'Edit',
          action: 'edit',
          severity: 'info',
          icon: 'pi pi-pencil'
        },
        {
          label: 'Delete',
          action: 'delete',
          severity: 'danger',
          icon: 'pi pi-trash'
        }
      ]
    }
  ],
  headerActions: [
    {
      label: 'Save',
      action: 'save',
      severity: 'primary',
      icon: 'pi pi-check'
    },
    {
      label: 'Cancel',
      action: 'cancel',
      severity: 'secondary',
      icon: 'pi pi-times'
    }
  ],
  listRoute: '/center-business/channel/goods-shop',
};
